"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NotificationNumber = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hoc = require("@apollo/client/react/hoc");
var _flowRight = _interopRequireDefault(require("lodash/flowRight"));
var _pubnubReact = require("pubnub-react");
var _styles = require("./styles");
var _PersistedApollo = require("../../../../../../PersistedApollo");
var _UnreadCountQuery = require("../apollo/UnreadCountQuery");
// istanbul ignore file

const NotificationNumber = _ref => {
  let {
    data,
    pubNubData,
    onMessageReceive,
    openAf,
    onNumberDisplayed,
    setAlertsFeedClicked
  } = _ref;
  const {
    channelName
  } = pubNubData;
  const pubnub = (0, _pubnubReact.usePubNub)();
  const [messages, addMessage] = (0, _react.useState)(0);
  const {
    loading,
    userNotifications: {
      unreadCount
    } = {}
  } = data;
  (0, _react.useEffect)(() => {
    if (!loading) {
      let count = 0;
      if (typeof unreadCount === 'number') {
        count = unreadCount;
      }
      addMessage(prevCount => prevCount + count);
    }
  }, [loading, unreadCount]);
  (0, _react.useEffect)(() => {
    const handleMessage = dataReceived => {
      const {
        message
      } = dataReceived;
      if (message.type === 'UPDATE_NOTIFICATION_READ') {
        addMessage(prevCount => {
          const rez = prevCount - message.content.markedIds.length;
          if (rez < 0) {
            return 0;
          }
          return rez;
        });
      }
      if (message.type === 'UPDATE_NOTIFICATION_UNREAD') {
        addMessage(prevCount => prevCount + message.content.markedIds.length);
        onMessageReceive();
      }
    };
    pubnub.addListener({
      message: handleMessage
    });
    pubnub.subscribe({
      channels: [channelName]
    });
    return () => {
      pubnub.unsubscribe({
        channels: [channelName]
      });
      pubnub.removeListener({
        message: handleMessage
      });
    };
  }, [channelName, openAf]);
  const displayCount = messagesCount => {
    if (messagesCount > 99) {
      return '99+';
    }
    return messagesCount.toString();
  };
  if (messages !== 0) {
    setAlertsFeedClicked(true);
    onNumberDisplayed();
    return /*#__PURE__*/_react.default.createElement(_styles.BadgeContainer, null, /*#__PURE__*/_react.default.createElement(_styles.Number, null, displayCount(messages)));
  }
  return null;
};
exports.NotificationNumber = NotificationNumber;
var _default = exports.default = (0, _flowRight.default)((0, _hoc.graphql)(_UnreadCountQuery.QUERY, {
  options: () => ({
    client: (0, _PersistedApollo.getFeedClient)(),
    fetchPolicy: 'network-only'
  })
}))(NotificationNumber);